import React, { useContext } from 'react';
import Card from '../Card/Card';
import { Colors } from '../../Context';
import Button from '../Button/Button';
import Paragraph from '../Paragraph/Paragraph';

const Red = () => {
           const { colorValueRed } = useContext(Colors);

           return (
                      <div className="flex fle-row justify-center mt-12">
                                 <Card className="w-[1800px] h-[555px] shadow-2xl shadow-[#000] bg-[#444] rounded-[24px]  ">
                                            <div className="m-4">
                                                       <Paragraph
                                                                  className="bg-[#0A7CFF] text-[24px] text-[#FFF] text-center rounded-[24px]"
                                                                  paragraphText="Red"
                                                       />
                                            </div>

                                            <div className="p-12 mt-2">
                                                       <Card className="grid grid-rows-2 grid-flow-col gap-4 ">
                                                                  {colorValueRed &&
                                                                             colorValueRed.map((item, index) => {
                                                                                        //console.log(item)
                                                                                        return (
                                                                                                   <div>
                                                                                                              <div
                                                                                                                         style={{ backgroundColor: `${item}` }}
                                                                                                                         className="w-[120px] h-[120px] rounded-[24px]"
                                                                                                              ></div>

                                                                                                              <Button
                                                                                                                         buttonText={item}
                                                                                                                         className="w-[100px] h-[50px] text-[#FFF] mx-2 mt-4 px-4 rounded-[24px]"
                                                                                                                         style={item}
                                                                                                              />


                                                                                                   </div>
                                                                                        );
                                                                             })}
                                                       </Card>
                                            </div>
                                 </Card>
                      </div>
           );
};

export default Red;
